module.exports = __webpack_public_path__ + "static/media/Bootstrap.e759a2ac.png";